import { Button } from "@/components/ui/button";
import { Leaf, ShieldCheck, HeartHandshake, ChevronRight } from "lucide-react";

export const HeroSection = () => {
  return (
    <section 
      className="relative min-h-screen pt-36 pb-16 overflow-hidden"
      data-testid="hero-section"
    >
      {/* Nature background image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1761400975692-981568516566?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxzb2Z0JTIwZ3JlZW4lMjBib3RhbmljYWwlMjBsZWF2ZXMlMjBsaWdodCUyMGFic3RyYWN0fGVufDB8fHx8MTc3MDQ0ODEzN3ww&ixlib=rb-4.1.0&q=85')`
        }}
      />
      
      {/* Gradient overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/80 to-white/60" />
      
      {/* Subtle green tint overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-sage/30 via-transparent to-sage/20" />
      
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-12 md:pt-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          <div className="space-y-8 opacity-0 animate-fade-up animate-fade-up-1">
            <div className="inline-flex items-center gap-2 bg-white/60 backdrop-blur-sm px-4 py-2 rounded-full border border-forest/10">
              <Leaf className="w-4 h-4 text-forest" />
              <span className="text-sm font-medium text-forest">Plant-Based Cleaning</span>
            </div>
            
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-forest leading-tight tracking-tight">
              Nature's Power
              <br />
              <span className="text-forest-light">in Every Drop</span>
            </h1>
            
            <p className="text-lg text-gray-600 max-w-lg leading-relaxed">
              Experience the perfect blend of nature and science. Our plant-based cleaning 
              products deliver powerful results while being gentle on your home and the environment.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <Button 
                onClick={() => document.getElementById("products").scrollIntoView({ behavior: "smooth" })}
                className="bg-forest hover:bg-forest-light text-white rounded-full px-8 py-6 text-lg btn-primary"
                data-testid="hero-explore-btn"
              >
                Explore Products
                <ChevronRight className="w-5 h-5 ml-2" />
              </Button>
              <Button 
                variant="outline"
                onClick={() => document.getElementById("features").scrollIntoView({ behavior: "smooth" })}
                className="border-2 border-forest text-forest hover:bg-forest hover:text-white rounded-full px-8 py-6 text-lg transition-colors"
                data-testid="hero-learn-btn"
              >
                Learn More
              </Button>
            </div>

            <div className="flex flex-wrap items-center gap-6 pt-4">
              <div className="flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-forest" />
                <span className="text-sm text-gray-600">Lab Tested</span>
              </div>
              <div className="flex items-center gap-2">
                <Leaf className="w-5 h-5 text-forest" />
                <span className="text-sm text-gray-600">Eco-Friendly</span>
              </div>
              <div className="flex items-center gap-2">
                <HeartHandshake className="w-5 h-5 text-forest" />
                <span className="text-sm text-gray-600">Cruelty Free</span>
              </div>
            </div>
          </div>

          <div className="relative flex justify-center lg:justify-end opacity-0 animate-fade-up animate-fade-up-2">
            <div className="relative">
              {/* Single product showcase image */}
              <div className="hero-product">
                <img 
                  src="https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/8fx9cgx8_IMG_5994.jpeg" 
                  alt="Plantora Products Collection"
                  className="w-full max-w-lg md:max-w-xl lg:max-w-2xl h-auto object-contain rounded-2xl shadow-2xl"
                  data-testid="hero-products-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-forest/30 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-forest/50 rounded-full" />
        </div>
      </div>
    </section>
  );
};
